module.exports = __webpack_public_path__ + "img/main_visual.d793d192.png";